// 本地nginx的地址
// export const baseUrl = 'http://localhost:4444/api/';

// 本地服务地址
export const baseUrl = 'http://localhost:4000/api/';

// 腾讯云ts服务地址
// export const baseUrl = 'http://118.25.6.134:4000/api/';
